module.exports = __webpack_public_path__ + "img/rdn.4d2034db.svg";